import styled from '@mui/material/styles/styled';
import TextField from '@mui/material/TextField';
import colors from 'src/utils/colors';

const CustomTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    height: '32px',
    borderRadius: '4px',
    border: `1px solid ${colors.graysSecondary}`,
    backgroundColor: '#fff',
    padding: '5px'
  },
  '& .MuiInputLabel-root': {
    display: 'none'
  },
  'input::-webkit-outer-spin-button,input::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: '0'
  },

  'input[type=number]': {
    '-moz-appearance': 'textfield'
  },

  input: {
    height: '19px',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: colors.darkBlue,
    padding: '0px'
  }
});

export default CustomTextField;
